import * as React from "react";
import { Collapse } from "react-collapse";
import Container from "./styled";
import { BsCheckLg, BsXLg } from "react-icons/bs";
import { Link } from "react-scroll";

class DropdownItem extends React.Component {
  render() {
    // Next Step
    const Continue = (e) => {
      e.preventDefault();
      const plan = {
        seguro: this.props.seguro,
        logo: this.props.logo,
        plan: this.props.plan,
        resCivil: this.props.resCivil,
        roboTotal: this.props.roboTotal,
        roboParcial: this.props.roboParcial,
        desTotal: this.props.desTotal,
        asistencia: this.props.asistencia,
        competencias: this.props.competencias,
        cuotas: this.props.cuotas,
        precioAnterior: this.props.precioAnterior,
        oferta: this.props.oferta,
        precio: this.props.precio,
        contratando: this.props.contratando,
      }
      this.props.planSelected(plan)
      this.props.nextStep();
    };
    return (
      <Container>
        {/* Dropdown */}
        <button
          className={this.props.isActive ? "headerBarOpen" : "headerBarClose"}
          onClick={this.props.clickFunction}
        >
          {/* Logo and Plan Container */}
          <div className="logoPlan opacidad6">
            <img alt="Logo Seguro" src={this.props.logo}></img>
            <p>{this.props.plan}</p>
          </div>
          {/* Checks Plan */}
          <section className="checksPlan opacidad6">
            {/* Check Responsabilidad Civil */}
            <span>
              {this.props.resCivil == "si" ? (
                <BsCheckLg />
              ) : (
                <BsXLg id="checkNo" />
              )}
            </span>
            {/* Check Robo Total */}
            <span>
              {this.props.roboTotal == "si" ? (
                <BsCheckLg />
              ) : (
                <BsXLg id="checkNo" />
              )}
            </span>
            {/* Check Robo Parcial */}
            <span>
              {this.props.roboParcial == "si" ? (
                <BsCheckLg />
              ) : (
                <BsXLg id="checkNo" />
              )}
            </span>
            {/* Check Destruccion Total */}
            <span>
              {this.props.desTotal == "si" ? (
                <BsCheckLg />
              ) : (
                <BsXLg id="checkNo" />
              )}
            </span>
            {/* Check Asistencia */}
            <span>
              {this.props.asistencia == "si" ? (
                <BsCheckLg />
              ) : (
                <BsXLg id="checkNo" />
              )}
            </span>
            {/* Check Competencias */}
            <span>
              {this.props.competencias == "si" ? (
                <BsCheckLg />
              ) : (
                <BsXLg id="checkNo" />
              )}
            </span>
            {/* Precios Container */}
            <div className="priceData">
              {/* Cuotas Container */}
              <div>
                {this.props.cuotas == "" ? null : (
                  <p
                    id={this.props.precio == "" && "cuotasBold"}
                    className={
                      this.props.precioAnterior == "" && "cuotasNaranja"
                    }
                  >
                    {this.props.cuotas}
                  </p>
                )}
                {this.props.precioAnterior == "" ? null : (
                  <p id="precioAnterior">{this.props.precioAnterior}</p>
                )}
              </div>
              {/* Precio */}
              {this.props.precio == "" ? null : (
                <div>
                  {this.props.oferta == "" ? null : <p>{this.props.oferta}</p>}
                  <p>{this.props.precio}</p>
                </div>
              )}
              {this.props.contratando == "" ? null : (
                <div>
                  <p>{this.props.contratando}</p>
                </div>
              )}
            </div>
            <div className="arrowContainer">
              <i></i>
            </div>
          </section>
          {/* Buttons Container */}
          <div className="buttonsContainer opacidad6">
            {/* Next Step Button */}
            <Link id="contrataButton" onClick={Continue} to="header" spy={true}>
              Contratá ahora
            </Link>
            {/* Ver mas Buttton */}
            <button id="verMasButton" onClick={this.props.clickFunction}>
              {this.props.isActive ? "Ver menos" : "Ver más"}
            </button>
          </div>
        </button>
        {/* Contenido */}
        <Collapse isOpened={this.props.isActive}>
          <div className="childrenContainer">{this.props.children}</div>
        </Collapse>
      </Container>
    );
  }
}

export default DropdownItem;
